<template>
  <section class="section container pt-0">
    <div class="title is-3">{{ $t("event calendar") }}</div>

    <full-calendar
      :options="calendarOptions"
      ref="full_calendar"
    ></full-calendar>
    <event-modal ref="event_modal" @updated="refresh" />
  </section>
</template>

<script>
import {
  put,
  error_message,
  get,
  api_host,
  post,
  error_alert,
  generate_error_message_text,
} from "@/utils";
import EventModal from "./event_modal/Index.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
// import rrulePlugin from "@fullcalendar/rrule";
import moment from "moment";
import { v4 } from "uuid";

export default {
  name: "CalendarIndex",
  components: { EventModal, FullCalendar },
  data() {
    let v = this;
    return {
      recurring_events: [],
      member: {},
      stations: [],
      availability: [],
      calendarOptions: {
        displayEventTime: false,
        customButtons: {
          refresh: {
            text: v.$t("refresh"),
            click: function () {
              v.refresh();
            },
          },
        },
        eventSources: [
          // {
          //   events: function (info, successCallback, failureCallback) {
          //     // console.log("event", info);
          //     get("/pilates_member/calendar", {
          //       start: info.startStr,
          //       end: info.endStr,
          //     })
          //       .then((response) => {
          //         // console.log("response", response);
          //         successCallback(
          //           response.map((e) => {
          //             e.color = moment(e.start).isBefore(moment())
          //               ? "gray"
          //               : "";
          //             return e;
          //           })
          //         );
          //       })
          //       .catch((error) => {
          //         console.error("error", error);
          //         failureCallback(error);
          //       });
          //   },
          // },
          {
            events: function (info, successCallback, failureCallback) {
              get("/eserman/event/all", {
                start: info.startStr,
                end: info.endStr,
              })
                .then((r) => {
                  // let recurring_events = r
                  //   .filter((i) => i.is_recurrent)
                  //   .map((e) => {
                  //     return {
                  //       title: e.customer,
                  //       id: e.uuid,
                  //       daysOfWeek: [2, 4],
                  //       // display: "background",
                  //     };
                  //   });

                  let arr = r
                    // .filter((i) => !i.is_recurrent)
                    .map((event) => {
                      let evt = {
                        id: event.uuid,
                        title: event.customer,
                        start: event.date,
                        // end: moment(event.date).add(1, "hour"),
                        allDay: false,
                        display: "block",
                        modul_evt: event,
                      };
                      return evt;
                    });

                  // let final_arr = recurring_events.concat(non_recurring_arr);
                  // console.log(arr);

                  successCallback(arr);
                })
                .catch((error) => {
                  error_message(error);
                  failureCallback(error);
                });
            },
          },
          // {
          //   url: `${api_host}/pilates_member/calendar`,
          //   method: "GET",
          //   failure: function (err) {
          //     console.error("There was an error while fetching events!", err);
          //   },
          // },
        ],
        // events: {
        //   url: `${api_host}/pilates_member/reservation/booking`, // use the `url` property
        //   method: "POST",
        // },

        // any other sources...

        allDaySlot: false,
        locale: v.$i18n.locale,
        // editable: true,
        nowIndicator: true,
        // now: true,
        buttonText: {
          today: v.$t("today"),
          month: v.$t("month"),
          week: v.$t("week"),
          day: v.$t("day"),
        },
        footerToolbar: {
          left: "prev,next,today refresh",
          center: "title",
          right: "refresh dayGridMonth,timeGridWeek,timeGridDay",
        },
        headerToolbar: {
          left: "prev,next,today refresh",
          center: "title",
          right: "refresh dayGridMonth,timeGridWeek,timeGridDay",
        },
        plugins: [
          dayGridPlugin,
          interactionPlugin,
          timeGridPlugin,
          // rrulePlugin,
        ],
        initialView: "dayGridMonth",
        eventClick: function (info) {
          // if (info.event._def.publicId)
          //    v.$refs.recurring_event_modal.edit_modal(info.event._def.publicId);
          v.$refs.event_modal.edit_modal(
            info.event._def.publicId,
            info.event._instance.range.start
          );
        },
        dateClick: function (info) {
          v.$refs.event_modal.show_modal(info);
          // Add event to fullcalendar
          // v.$refs.full_calendar.getApi().addEvent({
          //   id: v4(),
          //   start: info.dateStr,
          //   end: moment(info.dateStr).add(1, "hour").format(),
          // });
        },
        eventChange: function (info) {
          return false;
          // console.log("eventChange", info.event._def.publicId);
          // let event = v.calendarOptions.events.find(
          //   (e) => e.id === info.event._def.publicId
          // );
          // event.start = info.event.start;
          // event.end = info.event.end;
        },
        // events: [],
      },
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    make_reservation() {
      let v = this;
      v.$refs.reserve_modal.show_modal(v.availability);
    },
    refresh() {
      let v = this;
      v.$refs.full_calendar.getApi().refetchEvents();
    },
  },
  mounted() {},
  created() {
    // let v = this;
    // get("/pilates_member/calendar/classes", {})
    //   .then((r) => {
    //     console.log("recurring_events", r);
    //     v.recurring_events = r.map((e) => {
    //       return {
    //         title: e.coach,
    //         daysOfWeek: [moment(e.date).isoWeekday().toString()],
    //         startTime: moment(e.start_date).format("HH:mm"),
    //         endTime: moment(e.end_date).format("HH:mm"),
    //         display: "background",
    //       };
    //     });
    //     // let evnts = r.map((e) => {
    //     //   let day_of_week = e.iso_day_of_week;
    //     //   if (day_of_week == "7") day_of_week = "0";
    //     //   return {
    //     //     daysOfWeek: [day_of_week],
    //     //     startTime: e.from,
    //     //     endTime: e.to,
    //     //     display: "background",
    //     //   };
    //     // });
    //     // v.working_hours = evnts;
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style scoped></style>
